import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogMolds } from "../../../repositories/CatalogMoldRepository";
import { getCatalogMoldSizes } from "../../../repositories/CatalogMoldSizeRepository";
import { useCatalogMoldSizeContext } from "../../mold-sizes/context/CatalogMoldSizeContext";
import { TableMold } from "../components/TableMold";
import { useCatalogMoldContext } from "../context/CatalogMoldContext";
type Props = {};

export const CatalogMoldPage = (props: Props) => {
	const { state, actions } = useCatalogMoldContext();
	const {
		actions: { setMoldSizes },
	} = useCatalogMoldSizeContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");
	const searchMoldSizes = async () => {
		setIsLoading(true);
		const res = await getCatalogMoldSizes();
		if (res.ok) {
			setMoldSizes(res.data.tables[0].rows);
		} else {
			setError(res.message);
		}
		setIsLoading(false);
	};
	const getCatalogMoldsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogMolds();
		if (resp.ok) {
			actions.setMolds(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};
	useEffect(() => {
		getCatalogMoldsFromAPI();
		searchMoldSizes();
	}, []);
	if (state.molds) {
		return (
			<>
				<HelmetDexteel title="Molds - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableMold
								isLoading={isLoading}
								getCatalogMoldsFromAPI={getCatalogMoldsFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
